(function () {
    'use strict';

    angular.module("imApp").factory("checkListDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            listCheckListDatas: function (parms) {
                return $ihttp.post({
                    method: 230,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
